import api from './api';

export const termsAPI = {
  getAllTerms: async (params: { page?: number; limit?: number; type?: string }) => {
    const response = await api.get('/termsandconditions/getall', { params });
    return response.data;
  },
  createTerm: async (data: { type: 'Privacy-Policy' | 'Refund-Policy'; title: string; description: string }) => {
    const response = await api.post('/termsandconditions/add', data);
    return response.data;
  },
  updateTerm: async (id: string, data: { title?: string; description?: string }) => {
    const response = await api.put(`/termsandconditions/update/${id}`, data);
    return response.data;
  },
  deleteTerm: async (id: string) => {
    const response = await api.delete(`/termsandconditions/delete/${id}`);
    return response.data;
  },
};